// @flow

import { fromJS } from 'immutable';
import _ from 'lodash';

export const GET_VIDEO_DETAILS = 'aparatTV/Play/GET_VIDEO_DETAILS';
export const GET_VIDEO_DETAILS_SUCCESS = 'aparatTV/Play/GET_VIDEO_DETAILS_SUCCESS';
export const GET_VIDEO_DETAILS_FAIL = 'aparatTV/Play/GET_VIDEO_DETAILS_FAIL';
export const CLEAR_VIDEO_DETAILS = 'aparatTV/Play/CLEAR_VIDEO_DETAILS';

// Like action types
export const TOGGLE_LIKE = 'aparatTV/Play/TOGGLE_LIKE';
export const TOGGLE_LIKE_SUCCESS = 'aparatTV/Play/TOGGLE_LIKE_SUCCESS';
export const TOGGLE_LIKE_FAIL = 'aparatTV/Play/TOGGLE_LIKE_FAIL';

const initialState = fromJS({
  getVideoDetailsLoading: false,
  videoDetails: {},
  getVideoDetailsFail: null,
  likeStatus: null,
  likeLink: null,
  likeError: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_VIDEO_DETAILS:
      return state.merge({
        getVideoDetailsLoading: true,
        getVideoDetailsFail: null,
      });
    case GET_VIDEO_DETAILS_SUCCESS: {
      const likeData = _.get(action.data, ['Like', 'data']);
      return state.merge({
        getVideoDetailsLoading: false,
        videoDetails: fromJS(action.data),
        likeStatus: likeData ? likeData.status : null,
        likeLink: likeData ? likeData.link : null,
      });
    }
    case GET_VIDEO_DETAILS_FAIL:
      return state.merge({
        getVideoDetailsLoading: false,
        getVideoDetailsFail: fromJS(action.data),
      });
    case CLEAR_VIDEO_DETAILS:
      return state.merge({
        videoDetails: fromJS({}),
        likeStatus: null,
        likeLink: null,
      });
    case TOGGLE_LIKE_SUCCESS:
      return state.merge({
        likeStatus: action.data.status,
        likeLink: action.data.link,
        likeError: null,
      });
    case TOGGLE_LIKE_FAIL:
      return state.merge({
        likeError: action.data,
      });
    default:
      return state;
  }
};

export const getVideoDetails = (data : string) => (dispatch : any) =>
  dispatch({ type: GET_VIDEO_DETAILS, data });

export const clearVideoDetails = () => ({ type: CLEAR_VIDEO_DETAILS });

export const toggleLike = () => (dispatch : any, getState : any) => {
  const state = getState();
  const likeLink = state.getIn(['Play', 'likeLink']);
  if (likeLink) {
    return dispatch({ type: TOGGLE_LIKE, data: likeLink });
  }
  return null;
};
